import { skland } from "./skland";
export var container = {
    onReturn: function () {
        if (skland.isInContainer) {
            skland.onReturn();
        }
        return undefined;
    },
};
